<template>
  <div>
    <opcion-form
      :is-add-new-user-sidebar-active.sync="isAddNewSidebarActive"
      :form-type="formType"
      :padre="padre"
      :data-edit="dataEdit"
      :order="order"
      :select-grupopcion="dataGrupopcion"
      @refetch-data="refetchData"
      @error-data="showError"
    />
    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >
      <b-card-header>
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <b-card-title>Opción de {{ dataGrupopcion.descripcion }}</b-card-title>
        </b-col>

        <b-col
          cols="12"
          md="6"
        >
          <div class="d-flex align-items-center justify-content-end">
            <b-form-input
              v-model="query"
              class="d-inline-block mr-1"
              placeholder="Buscar..."
            />
            <b-button
              variant="primary"
              @click="openForm('new')"
            >
              <span class="text-nowrap">Nuevo</span>
            </b-button>
          </div>
        </b-col>
      </b-card-header>
      <b-card-body>
        <b-table
          ref="refUserListTable"
          class="position-relative"
          :items="items"
          responsive
          :fields="fields"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="No se encontraron registros"
          :busy="isBusy"
        >
          <template #table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">Cargando...</strong>
            </div>
          </template>
          <template #cell(estado)="data">
            <b-badge
              v-if="data.item.estado == true"
              pill
              variant="light-success"
              class="text-capitalize"
            >
              Activo
            </b-badge>

            <b-badge
              v-if="data.item.estado == false"
              pill
              variant="light-danger"
              class="text-capitalize"
            >
              Inactivo
            </b-badge>
          </template>
          <!-- Column: Actions -->
          <template #cell(acciones)="data">
            <b-dropdown
              variant="link"
              no-caret
              :right="$store.state.appConfig.isRTL"
            >

              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>

              <b-dropdown-item @click="getEdit(data)">
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">Editar</span>
              </b-dropdown-item>
              <b-dropdown
                id="dropdown-2"
                variant="link"
                no-caret
                :right="$store.state.appConfig.isRTL"
              >
                <template slot="button-content">
                  <feather-icon
                    icon="AlignJustifyIcon"
                    class="align-middle text-body"
                  />
                  <span>&nbsp;&nbsp;Gestión Hijos</span>
                </template>
                <b-dropdown-item
                  @click="getGenerateHijo(data)"
                >
                  Nuevo Hijos
                </b-dropdown-item>
                <b-dropdown-item
                  v-model="data.detailsShowing"
                  @click="showOpcionHijos(data)"
                >
                  Ver Hijos
                </b-dropdown-item>
              </b-dropdown>
              <!-- <b-dropdown-item @click="getGenerateHijo(data)">
                <feather-icon icon="AlignLeftIcon" />
                <span class="align-middle ml-50">Gestionar Hijos</span>
              </b-dropdown-item>
              <b-dropdown-item
                v-model="data.detailsShowing"
                style="display:inline-block"
                @click="showOpcionHijos(data)"
              >
                <feather-icon icon="AlignLeftIcon" />
                <span class="align-middle ml-50">Ver Hivos</span>
              </b-dropdown-item> -->
              <b-dropdown-item @click="getDelete(data)">
                <feather-icon icon="TrashIcon" />
                <span class="align-middle ml-50">Eliminar</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>
          <template #row-details="row">
            <b-card>
              <div v-if="row.item.padre === 0">
                <div class="d-flex mb-2 text-right">
                  <b-form-checkbox
                    v-model="row.detailsShowing"
                    style="display:inline-block"
                    @change="hideOpcionHijos()"
                  >
                    <span class="vs-label">Cerrar</span>
                  </b-form-checkbox>
                </div>
                <b-form-group>
                  <b-table
                    ref="refUserListTable"
                    class="position-relative"
                    :items="itemsGrupoHijos"
                    responsive
                    :fields="fieldsGrupoHijos"
                    primary-key="id"
                    show-empty
                    empty-text="No se encontraron registros"
                  >
                    <template #table-busy>
                      <div class="text-center text-primary my-2">
                        <b-spinner
                          variant="primary"
                          class="align-middle"
                        />
                        <strong class="ml-1">Cargando...</strong>
                      </div>
                    </template>
                    <template #cell(acciones)="data">
                      <b-dropdown
                        variant="link"
                        no-caret
                        :right="$store.state.appConfig.isRTL"
                      >
                        <template #button-content>
                          <feather-icon
                            icon="MoreVerticalIcon"
                            size="16"
                            class="align-middle text-body"
                          />
                        </template>
                        <b-dropdown-item @click="getEdit(data)">
                          <feather-icon icon="EditIcon" />
                          <span class="align-middle ml-50">Editar</span>
                        </b-dropdown-item>
                        <b-dropdown-item @click="getDelete(data)">
                          <feather-icon icon="TrashIcon" />
                          <span class="align-middle ml-50">Eliminar</span>
                        </b-dropdown-item>
                      </b-dropdown>
                    </template>
                  </b-table>
                </b-form-group>
              </div>
            </b-card>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>

            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">Mostrando {{ from }} a {{ to }} de {{ of }} registros</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >

              <b-pagination
                v-model="page"
                :total-rows="totalItems"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BBadge, BDropdown, BDropdownItem, BPagination, BSpinner, BCardHeader, BCardTitle, BCardBody, BFormGroup, BFormCheckbox,
} from 'bootstrap-vue'
import store from '@/store'
import moment from 'moment'
import OpcionForm from './OpcionForm.vue'

export default {
  components: {
    OpcionForm,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BFormGroup,
    BFormCheckbox,
  },
  props: {
    dataGrupopcion: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    isBusy: false,
    isDropdown2Visible: false,
    isAddNewSidebarActive: false,
    isOpenEditPassword: false,
    dataEdit: {},
    formType: '',
    page: 1,
    perPage: 10,
    totalRows: 0,
    totalItems: 0,
    totalPage: 0,
    from: 0,
    to: 0,
    padre: 0,
    of: 0,
    pageOptions: [10, 20, 50],
    sortBy: null,
    sortDesc: false,
    sortDirection: 'asc',
    itemsGrupoHijos: [],
    query: '',
    order: 1,
    items: [],
    fields: [
      { key: 'idOpcion', sortable: true, thClass: 'd-none', tdClass: 'd-none' },
      { key: 'grupoOpcion.descripcion', label: 'Grupo Opción', sortable: true },
      { key: 'valor', label: 'Valor', sortable: true },
      { key: 'label', sortable: true },
      { key: 'orden', sortable: true },
      { key: 'acciones' },
    ],
    fieldsGrupoHijos: [
      { key: 'idOpcion', sortable: true, thClass: 'd-none', tdClass: 'd-none' },
      { key: 'valor', label: 'Valor', sortable: true },
      { key: 'label', sortable: true },
      // { key: 'orden', sortable: true },
      { key: 'acciones' },
    ],
  }),
  watch: {
    dataGrupopcion: {
      handler() {
        this.listarRegistros()
      },
    },
    perPage: {
      handler() {
        this.listarRegistros()
      },
    },
    page: {
      handler() {
        this.listarRegistros()
      },
    },
    query: {
      handler() {
        this.listarRegistros()
      },
    },
  },
  mounted() {
    this.listarRegistros()
    this.$root.$on('bv::dropdown::show', bvEvent => {
      if (bvEvent.componentId === 'dropdown-2') {
        this.isDropdown2Visible = true
      }
    })
    this.$root.$on('bv::dropdown::hide', bvEvent => {
      if (bvEvent.componentId === 'dropdown-2') {
        this.isDropdown2Visible = false
      }
      if (this.isDropdown2Visible) {
        bvEvent.preventDefault()
      }
    })
  },
  methods: {
    listarRegistros() {
      this.isBusy = true
      if (this.dataGrupopcion.idGrupoOpcion !== undefined) {
        store
          .dispatch('gsencuesta/OPCION_FIND_ALL', {
            idGrupoOpcion: this.dataGrupopcion.idGrupoOpcion,
            limit: this.perPage,
            query: this.query,
            page: this.page,
            sortBy: 'orden%7CASC',
            padre: 0, // TODAS LAS OPCIONES
          })
          .then(response => {
            this.items = response.items
            this.totalRows = response.totalRows
            this.totalItems = response.totalItems
            this.totalPage = response.totalPage
            this.from = this.perPage * (this.page - 1) + (this.totalRows ? 1 : 0)
            this.to = this.perPage * (this.page - 1) + this.totalRows
            this.of = this.totalItems
            this.isBusy = false
            response.items.forEach(dat => {
              this.order = dat.orden
            })
            // console.log(this.order)
          })
          .catch(error => {
            this.showError(error)
            this.isBusy = false
          })
      }
    },
    openForm(type) {
      this.formType = type
      this.isAddNewSidebarActive = true
    },
    getEdit(data) {
      this.formType = 'edit'
      this.padre = 0
      this.isAddNewSidebarActive = true
      this.dataEdit = data.item
    },
    getGenerateHijo(data) {
      this.formType = 'edit'
      this.padre = 1
      this.isAddNewSidebarActive = true
      this.dataEdit = data.item
    },
    hideOpcionHijos() {
      this.items.forEach(item => {
        this.$set(item, '_showDetails', false)
      })
    },
    showOpcionHijos(data) {
      this.items.forEach(item => {
        this.$set(item, '_showDetails', false)
      })
      /* if (data.detailsShowing) {
        data.toggleDetails()
      } */
      data.toggleDetails()
      this.loadOpcionHijos(data.item.idOpcion)
    },
    loadOpcionHijos(idOpcion) {
      store
        .dispatch('gsencuesta/OPCION_FIND_HIJOS', {
          idOpcion,
        })
        .then(response => {
          if (response !== undefined) {
            this.itemsGrupoHijos = response
          }
        })
        .catch(error => {
          this.$bvToast.toast(error, {
            title: 'He ocurrido un error',
            variant: 'danger',
            solid: true,
          })
        })
    },
    getDelete(data) {
      this.$swal({
        title: '¿Está seguro de eliminar este registro?',
        text: 'Va eliminar un registro!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí',
        cancelButtonText: 'No',
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-primary ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          store
            .dispatch('gsencuesta/OPCION_DELETE', {
              id: data.item.idOpcion,
            })
            .then(response => {
              this.listarRegistros()
              this.$bvToast.toast('Ha Eliminado correctamente el registro.', {
                title: 'Operación Exitosa',
                variant: 'success',
                solid: true,
              })
              return response
            })
            .catch(error => {
              this.$bvToast.toast(error.response.data.errorMessage, {
                title: 'Ha ocurrido un error',
                variant: 'danger',
                solid: true,
              })
            })
        }
      })
    },
    refetchData(response) {
      let message = 'El proceso se ha ejecutado satisfactoriamente.'
      if (response.message) {
        message = response.message
      }
      this.$bvToast.toast(message, {
        title: 'Operación Extitosa',
        variant: 'success',
        solid: true,
      })
      this.listarRegistros()
    },
    showError(error) {
      let errorMessage = 'Intentelo en otro momento.'
      if (error.response) {
        errorMessage = error.response.data.errorMessage
      }
      this.$bvToast.toast(errorMessage, {
        title: 'Ha ocurrido un error',
        variant: 'danger',
        solid: true,
      })
    },
    getDateFmt(date) {
      return moment(String(date)).format('DD/MM/YYYY hh:mm a')
    },
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
